export enum QuotePartListSelectionAction {
  ADD_ALTERNATE_PART = 'addAlternatePart',
  ADD_NOTE = 'addNote',
  ADD_TO_CUSTOMER_ORDER = 'addToCustomerOrder',
  ADD_TO_CUSTOMER_QUOTE = 'addToCustomerQuote',
  ADD_TO_PRICING_PROFILE = 'addToPricingProfile',
  ADD_TO_VENDOR_ORDER = 'addToVendorOrder',
  ADD_TO_VENDOR_QUOTE = 'addToVendorQuote',
  APPLY_COST_DISCOUNT = 'applyCostDiscount',
  ASSIGN_VENDOR = 'assignVendor',
  CREATE_ORDER = 'createOrder',
  CREATE_PRICING_PROFILE = 'createPricingProfile',
  MOVE_TO = 'moveTo',
  REMOVE_NOTES = 'removeNotes',
  RESET_PRICING = 'resetPricing',
  UPDATE_MARGIN = 'updateMargin',
  UPDATE_PARTS = 'updateParts',
}

export enum QuotePartAddToPricingProfileOption {
  COST = 'cost',
  MARGIN = 'margin',
  PRICE = 'price',
}

export enum QuotePartAddToPricingProfileSubmitType {
  ADD_ALL = 'addAll',
  ADD_NEW = 'addNew',
}

export enum QuotePartStatus {
  ACTIVE = 'active',
  DELETED = 'deleted',
  OMITTED = 'omitted',
}

export enum QuotePartPriceGuidanceSourceType {
  EXTERNAL = 'external',
  LEGACY = 'legacy',
  MANUALLY_ENTERED = 'manually_entered',
  SALES_ORDER_HISTORY = 'sales_order_history',
}

export enum QuotePartUnifiedStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum PriceBasedOn {
  QUOTED = 'quoted',
  REPLACEMENT = 'replacement',
}

export enum PricingStrategy {
  EXTERNAL = 'external',
  PRICING_PROFILE = 'pricing_profile',
}

export enum QuotePartRecordType {
  PART = 'part',
  PART_DISCOUNT = 'part_discount',
  PRICING_GROUP_DISCOUNT = 'pricing_group_discount',
}

// The BE's `reason` on a trade-agreements line when `isSpaSelectionAvailable` is false.
export enum TradeAgreementUnavailableReason {
  COST_LOCKED = 'cost_locked',
  DISCOUNT_LINE = 'discount_line',
  LINE_ERROR = 'line_error',
  LOCKED = 'locked',
  NO_ENTITY_CODE = 'no_entity_code',
  NO_SELECTION_AVAILABLE = 'no_selection_available',
  NO_SKU_UOM = 'no_sku_uom',
  NOT_ALTERNATE = 'not_alternate',
  OMITTED = 'omitted',
  // The line has not been priced since the engine started answering the Select SPA flag.
  SELECTION_UNKNOWN = 'selection_unknown',
  SUBSTITUTED = 'substituted',
}

// `not_eligible` arrives as `not_eligible:<TradeAgreementUnavailableReason>`.
export enum ApplySelectedSpaSkipReason {
  // `already_selected` / `manual_cost` only come back when the prompt's option was unticked.
  ALREADY_SELECTED = 'already_selected',
  // The line already holds this agreement, same code and version.
  ALREADY_THIS_SPA = 'already_this_spa',
  // The lookup of the line's agreements failed; `save_failed` is the save of the pick.
  LINE_ERROR = 'line_error',
  MANUAL_COST = 'manual_cost',
  NOT_ELIGIBLE = 'not_eligible',
  NOT_IN_LIST = 'not_in_list',
  SAVE_FAILED = 'save_failed',
}

// What a listed agreement is to the line, as the Select SPA drawer's In use column says it.
export enum TradeAgreementUsage {
  // The line's default while a pick is held: choosing it removes the pick.
  DEFAULT = 'default',
  // The line's default, and the line is on it: nothing to choose.
  DEFAULT_IN_USE = 'defaultInUse',
  // The pick the line holds.
  IN_USE = 'inUse',
  NOT_IN_USE = 'notInUse',
}

// The cost validity dates the line form takes from the user.
export enum CostValidityEntry {
  NONE = 'none',
  // A typed cost: Valid since and Valid until.
  TYPED = 'typed',
  // A vendor quote cost whose vendor quote has no Valid until: that one only, on the line.
  VENDOR_QUOTE_VALID_UNTIL = 'vendorQuoteValidUntil',
}

// What a cost response does to the vendor quote Valid until the user gives.
export enum VendorQuoteValidUntilPrefill {
  KEEP = 'keep',
  // Back on the saved line's vendor quote: the saved line's own.
  SAVED = 'saved',
  // Come to another vendor quote: the one the quote's other lines on it share.
  SHARED = 'shared',
}
